<div class="panel panel--components" [@enterAnimation] *ngIf="equipmentSystems && equipmentDetails">
  <div class="sysheader">
    <div class="panel__header__title">
      {{
        equipmentSystems.SystemType === 'EqualiserBar'
          ? (equipmentSystems.SystemType | translate | async)
          : ((equipmentSystems.Side + ' Side ' + equipmentSystems.SystemType) | translate | async)
      }}
    </div>
    <div class="panel__header__title serialnumber divfixedwidth" *ngIf="isBasicUser==1 && equipmentSystems.SystemType !== 'EqualiserBar'">
      - {{equipmentSystems.SerialNumber}}
      <i class="material-icons" style="color: black; font-size: 16px; cursor: pointer;"
        (click)="EditSerial(equipmentSystems)">edit</i>
    </div>
    <!-- <div class="panel__header__title serialnumber framecondition divflex"
      *ngIf="isBasicUser==1 && (equipmentSystems.SystemType == 'Frame' || (equipmentSystems.SystemType == 'EqualiserBar' && IsCondition))">
      <span style="width: 130px;">
        {{(equipmentSystems.SystemType == 'EqualiserBar' ? 'Condition' : 'Frame Condition') | translate | async}}
      </span>
      <select class="frameconditionoptions" [ngModel]="equipmentSystems.SystemCondition"
        [ngStyle]="{ 'background-color': equipmentSystems.SystemConditionColor }"
        (change)="updateSystemCondition(equipmentSystems, $event.target.value)"
        [title]="isInspector ? ('Click to edit condition' | translate | async) : ''">
        <option value="A" class="frameconditionoptionscolorA">A</option>
        <option value="B" class="frameconditionoptionscolorB">B</option>
        <option value="C" class="frameconditionoptionscolorC">C</option>
        <option value="X" class="frameconditionoptionscolorX">X</option>
      </select>
    </div> -->
    <div class="panel__header__title serialnumber framecondition divflex"
      *ngIf="isBasicUser == 1 && (equipmentSystems.SystemType == 'Frame' || (equipmentSystems.SystemType == 'EqualiserBar' && IsCondition))">
      <span style="width: 130px;">
        {{ (equipmentSystems.SystemType == 'EqualiserBar' ? 'Condition' : 'Frame Condition') | translate | async }}
      </span>
      <select
        class="frameconditionoptions"
        [ngModel]="equipmentSystems.SystemType == 'EqualiserBar' ? equipmentSystems.Components[0]?.Condition : equipmentSystems.SystemCondition"
        [ngClass]="getConditionClass(equipmentSystems.SystemType == 'EqualiserBar' ? equipmentSystems.Components[0]?.Condition : equipmentSystems.SystemCondition)"
        (change)="updateSystemCondition(equipmentSystems, $event.target.value)"
        [title]="isInspector ? ('Click to edit condition' | translate | async) : ''">
        <option value="A" class="frameconditionoptionscolorA">A</option>
        <option value="B" class="frameconditionoptionscolorB">B</option>
        <option value="C" class="frameconditionoptionscolorC">C</option>
        <option value="X" class="frameconditionoptionscolorX">X</option>
      </select>
    </div>
  </div>
  <div class="panel__sub-header" *ngIf="isBasicUser==1">
    <div class="column-container flex-grow">
      <div class="column-container__column">
        <div class="text-block">
          <img class="chain-photo" *ngIf="FamilyImage_Chain && equipmentSystems.SystemType == 'Chain'"
            [src]="sanitize(FamilyImage_Chain)">
          <img class="chain-photo" src="/Content/Images/chain.jpg"
            *ngIf="!FamilyImage_Chain && equipmentSystems.SystemType == 'Chain'">
          <img class="chain-photo" *ngIf="FamilyImage_Frame && equipmentSystems.SystemType == 'Frame'"
            [src]="sanitize(FamilyImage_Frame)">
          <img class="chain-photo" src="/Content/Images/frame.jpg"
            *ngIf="!FamilyImage_Frame && equipmentSystems.SystemType == 'Frame'">
          <img class="equaliser-image" *ngIf="equipmentSystems.SystemType == 'EqualiserBar'"
            src="/Content/Images/EqualiserBarFront.png">
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{
            'Date Installed' | translate | async
            }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.DateInstalled | date: 'dd-MMM-yyyy' }}
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Equipment SMU/Hourmeter at Install' | translate | async }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.EquipmentSmuAtInstall}} hrs
          </span>
        </div>
        <div class="text-block" *ngIf="equipmentSystems.SystemType == 'Frame'">
          <span class="text-block__label">
            {{ 'Equipment DOE at Install' | translate | async }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.EquipmentDOEAtInstall}} km
          </span>
        </div>
      </div>
       <div class="column-container__column" *ngIf="equipmentSystems.SystemType == 'Frame'">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Hrs. on Frame at Install' | translate | async }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.HistoricalHours}} hrs
          </span>
        </div>
        <div class="text-block" >
          <span class="text-block__label">
            {{ 'Dist. on Frame at Install' | translate | async }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.HistoricalDistance}} km
          </span>
        </div>
      </div>
      <div class="column-container__column" *ngIf="equipmentSystems.SystemType == 'Frame' || equipmentSystems.SystemType== 'EqualiserBar'">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Budget Life' | translate | async }}
          </span>
          <span class="text-block__important">
            <span *ngIf="!(!editableSystemBudgetLife && (equipmentSystems.Id == currentClickedId))">
              {{equipmentSystems.BudgetLife}} hrs
              <i *ngIf="isInspector" class="material-icons text-container__edit"
                style="cursor: pointer; font-size :16px;" title="Edit Budget Life"
                (click)="editSysBudgetLife(equipmentSystems.Id)">edit</i>
            </span>
            <span *ngIf="!editableSystemBudgetLife && (equipmentSystems.Id == currentClickedId)"
              class="text-block__important divflex">
              <span>
                <input class="input-container__input" #dataInput [id]="'dataInputBudgetLife_' + equipmentSystems.id"
                  [value]="equipmentSystems.BudgetLife" [(ngModel)]="equipmentSystems.BudgetLife" focusOnShow />
              </span>
              <span>
                <i class="material-icons save-button__icon editcancel" title="Save Changes"
                  (click)="onSaveSysBudgetLife(equipmentSystems.Id,equipmentSystems.BudgetLife)">check</i>
              </span>
              <span>
                <i class="material-icons cancel-button__icon editcancel" title="Cancel Changes"
                  (click)="onCancelSysBudgetLife()">close</i>
              </span>
            </span>
          </span>
        </div>
        <div class="text-block" *ngIf="equipmentSystems.SystemType !== 'EqualiserBar'">
          <span class="text-block__label">
            {{ 'Distance Budget' | translate | async }}
          </span>
          <span class="text-block__important">
            <span *ngIf="!(!editableSysBudgetDistance && (equipmentSystems.Id == currentClickedId))">
              {{equipmentSystems.BudgetDistance}} km
              <i *ngIf="isInspector" class="material-icons text-container__edit"
                style="cursor: pointer; font-size :16px;" title="Edit Distance Budget"
                (click)="editSysBudgetDistance(equipmentSystems.Id)">edit</i>
            </span>
            <span *ngIf="!editableSysBudgetDistance && (equipmentSystems.Id == currentClickedId)"
              class="text-block__important divflex">
              <span>
                <input class="input-container__input" #dataInput [id]="'dataInputBudgetDistance_' + equipmentSystems.id"
                  [value]="equipmentSystems.BudgetDistance" [(ngModel)]="equipmentSystems.BudgetDistance" focusOnShow />
              </span>

              <i class="material-icons save-button__icon editcancel" title="Save Changes"
                (click)="onSaveSysBudgetDistance(equipmentSystems.Id,equipmentSystems.BudgetDistance)">check</i>
              <i class="material-icons cancel-button__icon editcancel" title="Cancel Changes"
                (click)="onCancelSysBudgetDistance()">close</i>
            </span>
          </span>
        </div>
      </div>
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Life Lived' | translate | async }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.LifeLived}} hrs
          </span>
        </div>
        <div class="text-block" *ngIf="equipmentSystems.SystemType == 'Frame'">
          <span class="text-block__label">
            {{ 'Life Lived' | translate | async }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.LifeLivedKm}} km
          </span>
        </div>
      </div>
      <div class="column-container__column" *ngIf="equipmentSystems.SystemType == 'Frame'">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'SMU At CO' | translate | async }}
              </span>
              <span class="text-block__important">
                {{equipmentSystems.SmuAtCO}} hrs
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ 'DOE At CO' | translate | async }}
              </span>
              <span class="text-block__important">
                {{equipmentSystems.DOEAtCO}} km
              </span>
            </div>
          </div>
          <div class="column-container__column" *ngIf="equipmentSystems.SystemType == 'Frame'">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Forecast Date of CO' | translate | async }}
              </span>
              <span class="text-block__important">
                {{equipmentSystems.SMUDateCO || '-'}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Forecast Date of CO' | translate | async }}
              </span>
              <span class="text-block__important">
                {{equipmentSystems.DOEDateCO || '-'}}
              </span>
            </div>
          </div>
      <div class="column-container__column" *ngIf="equipmentSystems.SystemType == 'Frame'">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Residual Life' | translate | async }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.BudgetLife > 0 ? equipmentSystems.BudgetLife - equipmentSystems.LifeLived : 0}} hrs
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Residual Life' | translate | async }}
          </span>
          <span class="text-block__important">
            {{equipmentSystems.BudgetDistance > 0 ? equipmentSystems.BudgetDistance - equipmentSystems.LifeLivedKm : 0}}
            km
          </span>
        </div>
      </div>
      <div class="column-container__column" *ngIf="equipmentSystems.SystemType =='Frame'">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Frame Cost' | translate | async }}
          </span>
          <span class="text-block__important">
            <span *ngIf="!(!editableFrameCost && (equipmentSystems.Id == currentClickedId))">
              {{equipmentSystems.FrameCost}} hrs
              <i *ngIf="isInspector" class="material-icons text-container__edit"
                style="cursor: pointer; font-size :16px;" title="Edit Budget Life"
                (click)="editSysFrameCost(equipmentSystems.Id)">edit</i>
            </span>
            <span *ngIf="!editableFrameCost && (equipmentSystems.Id == currentClickedId)"
              class="text-block__important divflex">
              <span>
                <input class="input-container__input" #dataInput [id]="'dataInputFrameCost_' + equipmentSystems.id"
                  [value]="equipmentSystems.FrameCost" [(ngModel)]="equipmentSystems.FrameCost" focusOnShow />
              </span>
              <span>
                <i class="material-icons save-button__icon editcancel" title="Save Changes"
                  (click)="onSaveSystemFrameCost(equipmentSystems.Id,equipmentSystems.FrameCost)">check</i>
              </span>
              <span>
                <i class="material-icons cancel-button__icon editcancel" title="Cancel Changes"
                  (click)="onCancelFrameCost()">close</i>
              </span>
            </span>
          </span>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Frame Repair Cost' | translate | async }}
          </span>
          <span class="text-block__important">
            $0.00
          </span>
        </div>
      </div>
      <div class="column-container__column" *ngIf="equipmentSystems.SystemType !== 'EqualiserBar'">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Total Purchase Cost (inc. Current Components)' | translate | async }}
          </span>
          <span class="text-block__important">
            ${{equipmentSystems.TotalComponentPurchaseCost}}.00
          </span>
        </div>
        <div class="text-block" *ngIf="equipmentSystems.SystemType == 'Frame'">
          <span class="text-block__label">
            {{ 'Total Component Repairs Cost (inc. All Components Ever)' | translate | async }}
          </span>
          <span class="text-block__important">
            ${{equipmentSystems.TotalComponentRepairsCost}}.00
          </span>
        </div>
      </div>
      <div class="column-container__column" *ngIf="equipmentSystems.SystemType != 'Frame' && equipmentSystems.SystemType != 'EqualiserBar'">
        <div class="text-block">
          <span class="text-block__label">
            {{ 'Total Component Repairs Cost (inc. All Components Ever)' | translate | async }}
          </span>
          <span class="text-block__important">
            ${{equipmentSystems.TotalComponentRepairsCost}}.00
          </span>
        </div>
      </div>
      <div class="column-container__column" *ngIf="equipmentSystems.SystemType == 'Frame'">
        <div class="text-block" *ngIf="showFrameConfiguration">
          <span class="text-block__label">
            {{ 'Frame Configuration' | translate | async }}
          </span>
          <span class="text-block__important">
            <ng-container *ngIf="equipmentSystems.ToeOutFrame == 0">
              Unknown
            </ng-container>
            <ng-container *ngIf="equipmentSystems.ToeOutFrame == 1">
              {{ 'Toe Out' | translate | async }}
            </ng-container>
            <ng-container *ngIf="equipmentSystems.ToeOutFrame == 2">
              {{ 'Straight' | translate | async }}
            </ng-container>
            <ng-container *ngIf="isInspector">
              <a (click)="openTrackCofiguration(1,equipmentSystems.ToeOutFrame,equipmentSystems.Id,equipmentSystems.Side)"
                *ngIf="isInspector">
                <i class="material-icons " style="color: black; font-size: 16px; cursor: pointer;">create</i>
              </a>
            </ng-container>
          </span>
        </div>
        <!-- <div class="text-block" *ngIf="!showradio"> -->
        <!-- This above check is removed and this new is added TT-9496  -->
        <div class="text-block" *ngIf="showCannonType">
          <span class="text-block__label">
            {{ 'Cannon Type' | translate | async }}
          </span>
          <span class="text-block__important">
            <ng-container *ngIf="equipmentSystems.CastFrame == 0">
              Unknown
            </ng-container>
            <ng-container *ngIf="equipmentSystems.CastFrame == 1">
              {{ 'Cast' | translate | async }}
            </ng-container>
            <ng-container *ngIf="equipmentSystems.CastFrame == 2">
              {{ 'Fabricated' | translate | async }}
            </ng-container>
            <ng-container *ngIf="isInspector">
              <a (click)="openTrackCofiguration(2,equipmentSystems.CastFrame,equipmentSystems.Id,equipmentSystems.Side)"
                *ngIf="isInspector">
                <i class="material-icons " style="color: black; font-size: 16px; cursor: pointer;">create</i>
              </a>
            </ng-container>
          </span>
        </div>
      </div>
      <div class="column-container__column mtm-10" *ngIf="equipmentSystems.SystemType == 'Frame' && enableBogieShim">
        <app-bogie-shim [bogieShimL]="equipmentSystems.BogieShimLeft" [bogieShimR]="equipmentSystems.BogieShimRight"
          [side]="equipmentSystems.Side" [isViewMode]="true" [showHistory]="true"
          [equipmentId]="equipmentID"></app-bogie-shim>
      </div>
    </div>
  </div>
  <div class="panel__content no-padding">
    <table class="table table--striped table--full-width">
      <thead>
        <tr class="th-align">
          <th *ngIf="equipmentSystems.SystemType != 'EqualiserBar'"></th>
          <th *ngIf="(equipmentDetails.FamilyId!=203 && equipmentSystems.SystemType != 'EqualiserBar')">{{'Worn%' | translate | async}}</th>
          <th *ngIf="(equipmentDetails.FamilyId==203 || IsHtdrolicShovelWorksLikeRSH) && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Average%' | translate | async}}
          </th>
          <th *ngIf="(equipmentDetails.FamilyId==203 || IsHtdrolicShovelWorksLikeRSH) && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Worst%' | translate | async}}
          </th>
          <th>{{'Component' | translate | async}}</th>
          <th *ngIf="equipmentSystems.SystemType != 'EqualiserBar'">{{'Pos' | translate | async}}</th>
          <th *ngIf="showReading && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">{{'Reading' | translate | async}}({{userUOM}})</th>
          <th *ngIf="showWorn0 && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">{{'0% Worn' | translate | async}}</th>
          <th *ngIf="showWorn100 && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">{{'100% Worn' | translate | async}}</th>
          <th *ngIf="showWorkOrder && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">{{'Work Order#' | translate | async}}</th>
          <th *ngIf="isBasicUser==1 && equipmentSystems.SystemType == 'EqualiserBar' && !IsCondition">
            {{'Center' | translate | async}} ({{userUOM}})
          </th>
          <th *ngIf="isBasicUser==1 && equipmentSystems.SystemType == 'EqualiserBar' && !IsCondition">
            {{'Outer Left' | translate | async}} ({{userUOM}})
          </th>
          <th *ngIf="isBasicUser==1 && equipmentSystems.SystemType == 'EqualiserBar' && !IsCondition">
            {{'Outer Right' | translate | async}} ({{userUOM}})
          </th>
          <th *ngIf="showBrand">{{'Brand' | translate | async}}</th>

          <th matTooltip="{{'Click to edit' | translate | async}}" matTooltipPosition="above"
            (click)="togglePencilClick()" *ngIf="isBasicUser==1 &&showBudgetLife && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Budget Life' | translate | async}}
          </th>
          <th matTooltip="{{'Click to edit' | translate | async}}" matTooltipPosition="above"
            (click)="togglePencilClickPropelBudget()" *ngIf="isBasicUser==1 &&showPropelBudget && equipmentDetails.ShowPropelHrsPerc">
            {{'Propel' | translate | async}} <br>{{'Budget Life' | translate | async}}
          </th>
          <th *ngIf="equipmentSystems.SystemType != 'Frame' && isBasicUser==1 && showBushTurned && equipmentSystems.SystemType != 'EqualiserBar'"
            title="Bush turn budget Hours / % worn">
            {{'B/Turn%' | translate | async}}
          </th>
          <!--*ngIf="showCMU && (equipmentDetails.FamilyId==177 || equipmentDetails.FamilyId==203) && isBasicUser==1"-->
          <th *ngIf="showCMU && equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'"
            title="Total operating hours/Total propel hours.">
            {{'CMU/PMU' | translate | async}}
          </th>
          <th *ngIf="showCMU && !equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'CMU' | translate | async}}
          </th>


          <th *ngIf="showResLife100 && !equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Res. Life' | translate | async}} 100%
          </th>
          <th *ngIf="showResLife120 && !equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Res. Life' | translate | async}} 120%
          </th>
          <th *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 &&showProjectedLife100 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Projected 100%' | translate | async}}
          </th>
          <th *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 &&showProjectedLife120 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Projected 120%' | translate | async}}
          </th>

          <th *ngIf="showResLife100 && equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <!-- {{'Res. Life 100% Hrs/Propel' | translate | async}} -->
            <span matTooltip="{{'Residual Life based on 100% budgeted hours/propel hours' | translate | async}}">{{
              'Res. Life' | translate | async}} 100% <br> Hrs/{{'Propel' | translate | async }}</span>
          </th>
          <th *ngIf="showResLife120 && equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span matTooltip="{{'Residual Life based on 120% budgeted hours/propel hours' | translate | async}}"> {{
              'Res. Life' | translate | async}} 120% <br> Hrs/{{'Propel' | translate | async }}</span>
          </th>
          <th *ngIf="equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 &&showProjectedLife100 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span matTooltip="{{'Projected Life based on 100% budgeted hours/propel hours' | translate | async}}">{{
              'Projected 100%' | translate | async}} <br> Hrs/{{'Propel' | translate | async }}</span>
          </th>
          <th *ngIf="equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && showProjectedLife120 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span matTooltip="{{'Projected Life based on 120% budgeted hours/propel hours' | translate | async}}">{{
              'Projected 120%' | translate | async}} <br> Hrs/{{'Propel' | translate | async }}</span>
          </th>
          <th *ngIf="isBasicUser==1 && showDifference && equipmentSystems.SystemType != 'EqualiserBar'">
            <ul>
              <li>
                <p> {{'Difference' | translate | async}}</p><img src="/Content/Images/colourCode.png">
              </li>
            </ul>
          </th>
          <th *ngIf="showDOC && isBasicUser==1 && equipmentDetails.EnableDistTravelledTracking && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'DOC ' | translate | async}} ({{userUOD}})
          </th>
          <th *ngIf="showResDOC100 && isBasicUser==1 && equipmentDetails.EnableDistTravelledTracking && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Res. DOC' | translate | async}} 100% ({{userUOD}})
          </th>
          <th *ngIf="showResDOC120 && isBasicUser==1 && equipmentDetails.EnableDistTravelledTracking && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Res. DOC' | translate | async}} 120% ({{userUOD}})
          </th>
          <th *ngIf="showInstallDate && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Install Date' | translate | async}}
          </th>
          <th *ngIf="showReplacementDate && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Replacement Date' | translate | async}}
          </th>
          <th *ngIf="isBasicUser==1 && showPurchaseCost && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Purchase Cost' | translate | async}}
          </th>
          <th *ngIf="isBasicUser==1 && showRepairCost && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Repairs Cost' | translate | async}}
          </th>
          <th *ngIf="showBudgetWearRate && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Budget' | translate | async}} <br> {{'Wear Rate'|translate | async}}
          </th>
          <th *ngIf="showActualWearRate && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            {{'Actual' | translate | async}} <br>{{'Wear Rate' | translate | async}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let component of equipmentSystems.Components ; let i = index">
          <td class="component-cell" *ngIf="!component.IsChild && equipmentSystems.SystemType != 'EqualiserBar'">
            <div class="component-photo-container">
              <img class="component-photo" [src]="component.Photo" />
            </div>
          </td>
          <td *ngIf="component.IsChild && equipmentSystems.SystemType != 'EqualiserBar'" class="line-cell">
            <div class="line-vert{{getChildRowPosition(component.Id)}}"></div>
            <div class="line-hor"></div>
          </td>
          <td *ngIf="(equipmentDetails.FamilyId == 203 || IsHtdrolicShovelWorksLikeRSH) && equipmentSystems.SystemType != 'EqualiserBar'">
            <div style="display: flex; flex-direction: row;">

              <span [ngClass]="GetEvalColour(component, component.PercentWorn?.toFixed(1))" style="margin-right: 7px;">
                <div>
                  <ng-container *ngIf="component.ToolId == toolType.YESorNO || component.ToolId == toolType.PassorFail">
                    {{'-'}}
                  </ng-container>
                  <ng-container *ngIf="component.ToolId != toolType.YESorNO && component.ToolId != toolType.PassorFail">
                    {{component.CalculatedWorn?.toFixed(1)}}%
                  </ng-container>
                </div>
              </span>
            </div>
          </td>

          <td *ngIf="equipmentSystems.SystemType != 'EqualiserBar'">
            <span *ngIf="!isParent(component.Id)"  class="worn-badge"
               [ngClass]="[GetEvalColour(component, component.PercentWorn.toFixed(1)),
                (!component.isLatest && component.Reading !== -1) ? 'prev-inspection-worn' : ''
                ]" [title]="(!component.isLatest && component.Reading !== -1) ? 'Results are not from latest inspection': ''">
              <div style="text-align: center !important; display: inline-block;">
                <!-- Eval tool -->
                <ng-container *ngIf="component.ToolId === toolType.Eval">
                  {{ component.EvalCode }}
                </ng-container>
                <ng-container *ngIf="component.ToolId === toolType.ConditionAssessment">
                  {{ component.EvalCode === 'A' ? 'Good' : component.EvalCode === 'B' ? 'Monitor' : component.EvalCode
                  === 'X' ? 'Failed' :'Good' }}
                  <!-- Monitor -->
                </ng-container>
                <!-- Yes/No or Pass/Fail -->
                <ng-container *ngIf="component.ToolId === toolType.YESorNO || component.ToolId === toolType.PassorFail">
                  {{'-'}}
                </ng-container>
                <!-- All others -->
                <ng-container
                  *ngIf="component.ToolId !== toolType.Eval && component.ToolId !== toolType.YESorNO && component.ToolId !== toolType.PassorFail && component.ToolId != toolType.ConditionAssessment">
                  {{ component.Reading === -1 ? '-' : (component.PercentWorn.toFixed(1) + '%') }}
                </ng-container>
              </div>
            </span>
          </td>
          <td>
            <div style="display: flex; flex-direction: row; ">
              <div *ngIf="component.ComponentPitch == null" title="{{component.Name}} " class="ComponentNameText">
                {{component.Name}}</div>
              <div *ngIf="component.ComponentPitch != null"
                title="{{component.Name + (component.ComponentPitch ? ' - Pitch:  ' + component.ComponentPitch + ' ' + userUOM : '')}} "
                class="ComponentNameText">
                {{component.Name + (component.ComponentPitch ? ' - Pitch: ' + component.ComponentPitch + ' ' + userUOM :
                '')}}
              </div>
              <span *ngIf="editComponent && !component.IsCompartHasChild">
                <i class="material-icons text-container__edit" style="cursor: pointer; font-size :16px;"
                  title="Click to edit Component" (click)="openEditComponentPopup(component, equipmentSystems.SystemType)">edit</i>
              </span>
            </div>
          </td>
          <td *ngIf="equipmentSystems.SystemType != 'EqualiserBar'">
            <div class="positionText" *ngIf="!component.IsChild">
              {{showPosition(component.Position,component.CompartTypeId)}}
            </div>
          </td>
          <td *ngIf="showReading && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <div *ngIf="!isParent(component.Id)">
              <div
                *ngIf="(component.IsChild || !isParent(component.Id)) && component.ToolId !== toolType.Eval && component.ToolId !== toolType.YESorNO && component.ToolId !== toolType.PassorFail">
                <span *ngIf="component.Reading != -1">{{component.Reading}}</span>
              </div>
              <div *ngIf="component.ToolId === 9">
                <span class="tool-button" title="{{'Change Eval' | translate | async}}">{{component.EvalCode }}</span>
              </div>
              <div *ngIf='component.ToolId === 7'>
                <span class="tool-button" title="{{ 'Change Component Yes/No' | translate | async }}">
                  {{ component.Reading === -1 ? 'U' : (component.Reading === 1 ? ('Yes' | translate | async)
                  : ('No' | translate | async)
                  )
                  }}
                </span>
              </div>
              <div *ngIf='component.ToolId ===10'>
                <span class="tool-button" title="{{ 'Change Component Pass/Fail' | translate | async }}">
                  {{
                  component.Reading === -1
                  ? 'U'
                  : (component.Reading === 1 ? ('Pass' | translate | async) : ('Fail' | translate | async)
                  )
                  }}
                </span>
              </div>
            </div>
          </td>
          <td *ngIf="showWorn0 && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'"><span
              *ngIf="!isParent(component.Id) && component.ToolId !== toolType.Eval &&  component.ToolId !== toolType.YESorNO && component.ToolId !== toolType.PassorFail">{{component.Worn0Percent}}</span>
          </td>
          <td *ngIf="showWorn100 && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'"><span
              *ngIf="!isParent(component.Id) && component.ToolId !== toolType.Eval &&  component.ToolId !== toolType.YESorNO && component.ToolId !== toolType.PassorFail">{{component.Worn100Percent}}</span>
          </td>
          <td *ngIf="showWorkOrder && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <div *ngIf="!component.IsChild">
              <span *ngIf="!(!editableWO && (component.Id == currentClickedId))">
                {{component.ActionWO}}
                <span *ngIf="component.ActionWO != ''">
                  <i class="material-icons text-container__edit" style="cursor: pointer; font-size :16px;"
                    (click)="editWO(component.Id)">edit</i>
                </span>
              </span>
              <span *ngIf="!editableWO && (component.Id == currentClickedId)" class="text-block__important">
                <span>
                  <input class="input-container__input" #dataInput [id]="'dataInput_' + component.id"
                    [value]="component.ActionWO" [(ngModel)]="component.ActionWO" focusOnShow />
                </span>
                <i class="material-icons save-button__icon editcancel"
                  (click)="onSaveWO(component.ActionWOId,component.ActionWO)">check</i>
                <i class="material-icons cancel-button__icon editcancel" (click)="onCancelWO()">close</i>
              </span>
            </div>
          </td>
          <td *ngIf="isBasicUser==1 && equipmentSystems.SystemType == 'EqualiserBar' && !IsCondition">
            {{component.MeasurementCenter ?? '-' }}
          </td>
          <td *ngIf="isBasicUser==1 && equipmentSystems.SystemType == 'EqualiserBar' && !IsCondition">
            {{component.MeasurementOuterLeft ?? '-' }}
          </td>
          <td *ngIf="isBasicUser==1 && equipmentSystems.SystemType == 'EqualiserBar' && !IsCondition">
            {{component.MeasurementOuterRight ?? '-' }}
          </td>
          <td title="{{getTitle(component)}}" *ngIf="showBrand"><span
              *ngIf="!component.IsChild">{{component.Brand}}</span></td>
          <td *ngIf="isBasicUser==1 && showBudgetLife && equipmentSystems.SystemType != 'EqualiserBar'" style="padding: 0px;">
            <span *ngIf="!component.IsChild">
              <span *ngIf="!(!editableBudgetLife && (component.Id == currentClickedId))">
                {{component.BudgetLife}}
                <span *ngIf="TogglePencil">
                  <i class="material-icons text-container__edit" style="cursor: pointer; font-size :16px;"
                    (click)="editBudgetLife(component.Id)">edit</i>
                </span>
              </span>
              <span *ngIf="!editableBudgetLife && (component.Id == currentClickedId)" class="text-block__important">
                <span>
                  <input class="input-container__input" #dataInput [id]="'dataInput_' + component.id"
                    [value]="component.BudgetLife" [(ngModel)]="component.BudgetLife" focusOnShow />
                </span>
                <i class="material-icons save-button__icon editcancel"
                  (click)="onSaveBudgetLife(component.Id,component.BudgetLife,component.Name)">check</i>
                <i class="material-icons cancel-button__icon editcancel" (click)="onCancelBudgetLife()">close</i>
              </span>
            </span>
          </td>
           <td *ngIf="isBasicUser==1 && equipmentDetails.ShowPropelHrsPerc && showPropelBudget" >
            <span *ngIf="!component.IsChild">
              <span *ngIf="!(!editablePropelBudgetLife && (component.Id == currentClickedId))">
                {{component.PropelBudget}}
                <span *ngIf="TogglePencilPropel">
                  <i class="material-icons text-container__edit" style="cursor: pointer; font-size :16px;"
                    (click)="editPropelBudgetLife(component.Id)">edit</i>
                </span>
              </span>
              <span *ngIf="!editablePropelBudgetLife && (component.Id == currentClickedId)" class="text-block__important">
                <span>
                  <input class="input-container__input" #dataInput [id]="'dataInput_' + component.id"
                    [value]="component.PropelBudget" [(ngModel)]="component.PropelBudget" focusOnShow />
                </span>
                <i class="material-icons save-button__icon editcancel"
                  (click)="onSavePropelBudgetLife(component.Id,component.PropelBudget,equipmentSystems.Id,component.Name)">check</i>
                <i class="material-icons cancel-button__icon editcancel" (click)="onCancelPropelBudgetLife()">close</i>
              </span>
            </span>
          </td>
          <!-- When Bush not turned -->
          <td
            *ngIf="showBushTurned && equipmentSystems.SystemType != 'Frame' && component.BushTurnedBudgetLife!=null && isBasicUser==1 && !component.IsBushTurned && equipmentSystems.SystemType != 'EqualiserBar'">
            <div *ngIf="!component.IsChild">
              <span [ngClass]="getBushTurnbackgroudColour(component)" class="bush-turn-badge">
                <div>{{ component.BushTurnedPercent }}% /
                  {{ component.BushTurnedCalc | number:'1.0-0' }}
                </div>
                <div>
                  Hrs to turn {{ component.BushTurnRemainingHours | number:'1.0-0' }}
                </div>
              </span>
            </div>
          </td>
          <!-- When Bush turned -->
          <td
            *ngIf=" showBushTurned &&equipmentSystems.SystemType != 'Frame' && component.BushTurnedBudgetLife!=null && isBasicUser==1 && component.IsBushTurned && equipmentSystems.SystemType != 'EqualiserBar'">
            <span class="bush-turn-badge" style="background-color: #98fb98 ;">
              <div>Turned ✓ {{ component.CmuAtTurn | number:'1.0-0' }}</div>
              <div>
                Hrs since turn {{ component.AfterBushTurnedHours | number:'1.0-0' }}
                <div>Res. Hrs {{ component.BushTurnResidualLife | number:'1.0-0' }}</div>
              </div>
            </span>
          </td>
          <td
            *ngIf="equipmentSystems.SystemType != 'Frame' && component.BushTurnedBudgetLife==null && isBasicUser==1 && showBushTurned && equipmentSystems.SystemType != 'EqualiserBar'">
          </td>
          <td *ngIf="showCMU && !equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span *ngIf="!component.IsChild">{{component.Cmu}}</span>
          </td>
          <td *ngIf="showCMU && equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">

            <span *ngIf="!component.IsChild">{{component.Cmu}}/{{component.PMU}}</span>
          </td>
          <td *ngIf="showResLife100 && !equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span *ngIf="!component.IsChild">{{component.RemainingLife100}}</span>
          </td>
          <td *ngIf="showResLife120 && !equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span *ngIf="!component.IsChild"> {{component.RemainingLife120}}</span>
          </td>
          <td *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && showProjectedLife100 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span *ngIf="!component.IsChild">{{component.ProjectedLife100}}</span>
          </td>
          <td *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 && showProjectedLife120 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span *ngIf="!component.IsChild">{{component.ProjectedLife120}}</span>
          </td>
          <td *ngIf="showResLife100 && equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 &&showResLife100 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span
              *ngIf="!component.IsChild">{{component.RemainingLife100}}/{{component.PropelRemainingLife100.toFixed(0)}}</span>
          </td>
          <td *ngIf="showResLife120 && equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 &&showResLife120 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span
              *ngIf="!component.IsChild">{{component.RemainingLife120}}/{{component.PropelRemainingLife120.toFixed(0)}}</span>
          </td>
          <td *ngIf="equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 &&showProjectedLife100 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span
              *ngIf="!component.IsChild">{{component.ProjectedLife100}}/{{component.PropelProjectedLife100.toFixed(0)}}</span>
          </td>
          <td *ngIf="equipmentDetails.ShowPropelHrsPerc && isBasicUser==1 &&showProjectedLife120 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span
              *ngIf="!component.IsChild">{{component.ProjectedLife120}}/{{component.PropelProjectedLife120.toFixed(0)}}</span>
          </td>
          <td *ngIf="showDifference && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <div *ngIf="!component.IsChild">
              <span class="right-align ">
                <div class=" difference {{getDifferenceClass(component.Difference)}}"
                  title=" %Difference = (Projected Life 100% - Budget Life)/Budget Life %Difference =  {{ ((component.Difference/component.BudgetLife)*100 ).toFixed(2) }} % ">
                  {{ getAbs(component.Difference)}}
                </div>
              </span>
            </div>
          </td>
          <td *ngIf="showDOC && isBasicUser==1 && equipmentDetails.EnableDistTravelledTracking && equipmentSystems.SystemType != 'EqualiserBar'"
            style="padding:8px !important;">
            {{convertDistanceKmToMi(component.DOC)}}
          </td>
          <td *ngIf="showResDOC100 && isBasicUser==1 && equipmentDetails.EnableDistTravelledTracking && equipmentSystems.SystemType != 'EqualiserBar'"
            style="padding:8px !important;">
            {{convertDistanceKmToMi(component.ResDOC100)}}</td>
          <td *ngIf="showResDOC120 && isBasicUser==1 && equipmentDetails.EnableDistTravelledTracking && equipmentSystems.SystemType != 'EqualiserBar'"
            style="padding:8px !important;">
            {{convertDistanceKmToMi(component.ResDOC120)}}</td>
          <td *ngIf="showInstallDate && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar' "><span *ngIf="!component.IsChild">{{component.InstallDate |
              date:'dd-MMM-yyyy'}}</span></td>
          <td *ngIf="showReplacementDate && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'"><span
              *ngIf="!component.IsChild">{{component.ReplacementDate | date:'dd-MMM-yyyy'}}</span></td>
          <td *ngIf="isBasicUser==1 && showPurchaseCost && equipmentSystems.SystemType != 'EqualiserBar'">
            <span *ngIf="!component.IsChild">{{component.PurchaseCost | currency}}</span>
          </td>
          <td *ngIf="isBasicUser==1 && showRepairCost && equipmentSystems.SystemType != 'EqualiserBar'"><span *ngIf="!component.IsChild">{{component.RepairsCost|
              currency}}</span></td>
          <td *ngIf="showBudgetWearRate && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'"><span *ngIf="!component.IsChild">{{ component.BudgetLife /
              100 | number:'1.1-1' }}</span></td>
          <td *ngIf="showActualWearRate && isBasicUser==1 && equipmentSystems.SystemType != 'EqualiserBar'">
            <span *ngIf="!component.IsChild">
              <span *ngIf="component.PercentWorn < 30; else showActual">
                {{ component.BudgetLife / 100 | number:'1.1-1' }}
              </span>

              <ng-template #showActual>
                <span>
                  {{ component.Cmu / component.PercentWorn | number:'1.1-1' }}
                </span>
              </ng-template>

            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
